exports.OFFLINE_ERROR = 'not_available_offline'
